import React, { Component } from 'react';
import { Avatar, Button, Card, Icon, List } from 'antd';
import { Link } from 'react-router';
import './index.less';

class ProductIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    const data = [
      '',
      {
        title: 'Title 1',
      },
      {
        title: 'Title 2',
      },
      {
        title: 'Title 3',
      },
      {
        title: 'Title 4',
      },
      {
        title: 'Title 5',
      },
      {
        title: 'Title 6',
      },
    ];
    return (
      <div className="productIndex">
        <List
          grid={{ gutter: 24, lg: 3, md: 2, sm: 1, xs: 1 }}
          dataSource={data}
          renderItem={item =>
            item ? (
              <List.Item>
                <Card actions={[]}>
                  <Card.Meta
                    avatar={
                      <Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
                    }
                    title="技术支撑"
                    description="产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产
                    品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍产品介绍"
                  />
                </Card>
              </List.Item>
            ) : (
              <List.Item>
                <Link to="/client/product/add">
                  <Button type="dashed" className="newButton">
                    <Icon type="plus" /> 新建产品
                  </Button>
                </Link>
              </List.Item>
            )
          }
        />
      </div>
    );
  }
}

export default ProductIndex;



// WEBPACK FOOTER //
// ./src/components/client/product/Index.js